// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type MarketVarianceThresholdOverride,
  type MarketVarianceThresholdOverrideWireFormat,
  NewMarketVarianceThresholdOverride,
} from '../MarketVarianceThresholdOverride/MarketVarianceThresholdOverride';

export class VarianceThresholdSettings {
  readonly onTrackVarianceThreshold: string;
  readonly warningVarianceThreshold: string;
  readonly marketOverrides: MarketVarianceThresholdOverride[];

  constructor(data: { [key: string]: any } = {}) {
    this.onTrackVarianceThreshold =
      data.onTrackVarianceThreshold === undefined ? '0' : data.onTrackVarianceThreshold;
    this.warningVarianceThreshold =
      data.warningVarianceThreshold === undefined ? '0' : data.warningVarianceThreshold;
    this.marketOverrides = (data.marketOverrides ?? []).map((marketOverrides: any) =>
      NewMarketVarianceThresholdOverride(marketOverrides),
    );
  }

  static zero(): VarianceThresholdSettings {
    const zeroValues: ExcludeMethodsDeep<VarianceThresholdSettings> = {
      onTrackVarianceThreshold: '0',
      warningVarianceThreshold: '0',
      marketOverrides: [],
    };
    return new VarianceThresholdSettings(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type VarianceThresholdSettingsWireFormat = {
  onTrackVarianceThreshold: string;
  warningVarianceThreshold: string;
  marketOverrides: MarketVarianceThresholdOverrideWireFormat[];
};

type NewVarianceThresholdSettingsProps = PartialDeep<
  VarianceThresholdSettings,
  { recurseIntoArrays: true }
>;
export const NewVarianceThresholdSettings: (
  props: NewVarianceThresholdSettingsProps,
) => VarianceThresholdSettings = (props) => new VarianceThresholdSettings(props);

type NewVarianceThresholdSettingsFromWireFormatProps = PartialDeep<
  VarianceThresholdSettingsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewVarianceThresholdSettingsFromWireFormat: (
  props: NewVarianceThresholdSettingsFromWireFormatProps,
) => VarianceThresholdSettings = (props) => new VarianceThresholdSettings(props);
